



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class DashCard extends Vue {
  @Prop({ type: String, default: "" }) readonly icon!: string;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: Boolean, default: false }) readonly heightFull!: boolean;
  @Prop({ type: String, default: "" }) readonly bodyGap!: string;
}
export default DashCard;
